<!-- 审批流程管理 -->
<template>
  <div class="wraper">
    <div class="title">流程列表</div>
    <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
      <el-table-column
        prop="processName"
        label="流程名称"
        min-width="160"
      ></el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <span style="font-weight:bold">{{ formatState(scope.row.state) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="minPrice"
        label="最小金额（元）"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="最大金额（元）"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ formatMaxPrice(scope.row.maxPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审批节点1" min-width="140">
        <template slot-scope="scope">
          <span v-html="formatNode(scope.row.node1)"></span>
        </template>
      </el-table-column>
      <el-table-column label="审批节点2" min-width="140">
        <template slot-scope="scope">
          <span v-html="formatNode(scope.row.node2)"></span>
        </template>
      </el-table-column>
      <el-table-column label="审批节点3" min-width="140">
        <template slot-scope="scope">
          <span v-html="formatNode(scope.row.node3)"></span>
        </template>
      </el-table-column>
      <el-table-column label="审批节点4" min-width="140">
        <template slot-scope="scope">
          <span v-html="formatNode(scope.row.node4)"></span>
        </template>
      </el-table-column>
      <el-table-column label="审批节点5" min-width="140">
        <template slot-scope="scope">
          <span v-html="formatNode(scope.row.node5)"></span>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-button v-if="permissions.owsp_approvalProcess_update" @click.stop="write(scope.row)" type="text" size="small">编辑</el-button>
          <el-button v-if="(scope.row.state === 0) && permissions.owsp_approvalProcess_able" @click="enable(scope.row)" type="text" size="small">启用</el-button>
          <el-button v-if="(scope.row.state === 1) && permissions.owsp_approvalProcess_able" @click="enable(scope.row)" type="text" size="small">停用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑弹框 -->
    <el-dialog
      :title="writeTitle"
      width="1045px"
      :visible.sync="writeVisible"
    >
      <div class="bidOrder">
        <p class="wptext">为不同审核设置审批节点，如未设置则说明该费用区间无需审核</p>
        <div class="seemTable">
          <div class="columnHead">
            <div class="part n1">区间</div>
            <div class="part n2">最小金额（元）</div>
            <div class="part n3">最大金额（元）</div>
            <div class="part n4">审批节点1</div>
            <div class="part n5">审批节点2</div>
            <div class="part n6">审批节点3</div>
            <div class="part n7">审批节点4</div>
            <div class="part n8">审批节点5</div>
          </div>
          <div class="dataItem">
            <span class="part n1">区间1</span>
            <span class="part n2">{{writeRow.detail[0].minPrice}}</span>
            <span class="part n3">∞</span>
            <div class="part n4">
              <el-select :multiple-limit="5" v-model="writeRow.detail[0].node1" multiple filterable size="mini" @change="selChange(1)" placeholder="请选择">
                <el-option
                  v-for="tag in options"
                  :key="tag.userId"
                  :label="tag.userName"
                  :value="tag.userId">
                </el-option>
              </el-select>
            </div>
            <div class="part n5">
              <el-select :multiple-limit="5" v-model="writeRow.detail[0].node2" :disabled="writeRow.detail[0].node1.length < 1" multiple filterable size="mini" @change="selChange(2)" placeholder="请选择">
                <el-option
                  v-for="tag in options"
                  :key="tag.userId"
                  :label="tag.userName"
                  :value="tag.userId">
                </el-option>
              </el-select>
            </div>
            <div class="part n6">
              <el-select :multiple-limit="5" v-model="writeRow.detail[0].node3" :disabled="writeRow.detail[0].node2.length < 1" multiple filterable size="mini" @change="selChange(3)" placeholder="请选择">
                <el-option
                  v-for="tag in options"
                  :key="tag.userId"
                  :label="tag.userName"
                  :value="tag.userId">
                </el-option>
              </el-select>
            </div>
            <div class="part n7">
              <el-select :multiple-limit="5" v-model="writeRow.detail[0].node4" :disabled="writeRow.detail[0].node3.length < 1" multiple filterable size="mini" @change="selChange(4)" placeholder="请选择">
                <el-option
                  v-for="tag in options"
                  :key="tag.userId"
                  :label="tag.userName"
                  :value="tag.userId">
                </el-option>
              </el-select>
            </div>
            <div class="part n8">
              <el-select :multiple-limit="5" v-model="writeRow.detail[0].node5" :disabled="writeRow.detail[0].node4.length < 1" multiple filterable size="mini" @change="selChange(5)" placeholder="请选择">
                <el-option
                  v-for="tag in options"
                  :key="tag.userId"
                  :label="tag.userName"
                  :value="tag.userId">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="writeVisible = false">取消</el-button>
        <el-button size="mini" type="danger" :loading="wloading" @click="writeSure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      permissions: {
				owsp_approvalProcess_update: false,  //编辑
        owsp_approvalProcess_able: false     //停用/启用
			},
      tableLoading: false,
      wloading: false,
      tableData: [],
      writeVisible: false,
      writeTitle: '编辑',
      writeRow:{
        processId: null,
        detail: [
          {
            minPrice: 0,
            node1: [],
            node2: [],
            node3: [],
            node4: [],
            node5: []
          }
        ]
      },
      options: []
    };
  },
  created() {
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
  },
  mounted() {
    this.getTableData();
    this.getPeople();
  },
  methods: {
    ...mapActions([
      "fecthTableData",
      "processSwitch",
      "getEmployeeListApi1",
      "writeDataApi"
      ]),
    // 表格数据获取
    getTableData() {
      this.tableLoading = true;
      let params = {};
      this.fecthTableData(params)
        .then((res) => {
          this.tableData = res;
        })
        .catch((e) => {})
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 编辑
    write(row) {
      this.resetRow()
      this.writeTitle = row.processName
      this.writeRow.processId = row.processId
      this.writeRow.detail[0].minPrice = row.minPrice
      if(row.node1) {
        row.node1.forEach(item => {
          if(item.userId) {
            this.writeRow.detail[0].node1.push(item.userId)
          }
        })
      }
      if(row.node2) {
        row.node2.forEach(item => {
          if(item.userId) {
            this.writeRow.detail[0].node2.push(item.userId)
          }
        })
      }
      if(row.node3) {
        row.node3.forEach(item => {
          if(item.userId) {
            this.writeRow.detail[0].node3.push(item.userId)
          }
        })
      }
      if(row.node4) {
        row.node4.forEach(item => {
          if(item.userId) {
            this.writeRow.detail[0].node4.push(item.userId)
          }
        })
      }
      if(row.node5) {
        row.node5.forEach(item => {
          if(item.userId) {
            this.writeRow.detail[0].node5.push(item.userId)
          }
        })
      }
      this.writeVisible = true
    },
    // 编辑行数据重置
    resetRow() {
      this.writeRow.processId = null;
      this.writeRow.detail[0].minPrice = 0;
      this.writeRow.detail[0].node1 = [];
      this.writeRow.detail[0].node2 = [];
      this.writeRow.detail[0].node3 = [];
      this.writeRow.detail[0].node4 = [];
      this.writeRow.detail[0].node5 = [];
    },
    // 编辑框-审批节点下拉选择值变化
    selChange(cNode) {
      switch(cNode) {
        case 1:
          if(this.writeRow.detail[0].node1.length < 1) {
            this.writeRow.detail[0].node2 = []
            this.writeRow.detail[0].node3 = []
            this.writeRow.detail[0].node4 = []
            this.writeRow.detail[0].node5 = []
          }
          break;
        case 2:
          if(this.writeRow.detail[0].node2.length < 1) {
            this.writeRow.detail[0].node3 = []
            this.writeRow.detail[0].node4 = []
            this.writeRow.detail[0].node5 = []
          }
          break;
        case 3:
          if(this.writeRow.detail[0].node3.length < 1) {
            this.writeRow.detail[0].node4 = []
            this.writeRow.detail[0].node5 = []
          }
          break;
        case 4:
          if(this.writeRow.detail[0].node4.length < 1) {
            this.writeRow.detail[0].node5 = []
          }
          break;
        default:
          return false;
          break;
      }
    },
    // 编辑确定
    writeSure() {
      this.wloading = true
      this.writeDataApi(this.writeRow).then(res => {
        this.wloading = false
        this.writeVisible = false
        this.getTableData();
      }).catch(e => {
        this.wloading = false
      })
    },
    // 审批节点下拉人员选项接口
    getPeople() {
      let parama = {
        userName: "",
        telephone: "",
        identity: "",
        roleName: "",
        orgName: "",
        state: '1',
        pageNum: 1,
        pageSize: 100000
      }
      this.getEmployeeListApi1(parama).then(res => {
        this.options = res.rows
      }).catch(e => { });
    },
    // 启用/停用
    enable(row) {
      let params = {
        processId: row.processId
      }
      this.processSwitch(params)
        .then((res) => {
          this.getTableData()
        })
        .catch((e) => {})
        .finally(() => {});
    },
    formatState(val) {
      let res = '';
      switch (val) {
        case 0: res = '未启用'; break;
        case 1: res = '已启用'; break;
        default: res = ''; break;
      }
      return res;
    },
    formatMaxPrice(val) {
      if(val) {
        return val
      } else {
        return "∞"
      }
    },
    formatNode(obj) {
      if(obj instanceof Array && obj.length > 0) {
        let str = ''
        obj.forEach(item => {
          str+= `<span>${item.name}/${item.phone}</span><br>`
        })
        return str
      }
      return '/'
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-tag {
  padding: 0px 6px !important;
  margin: 2px !important;
}
.wraper {
  padding: 27px 24px !important;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium;
    color: #000000;
    font-weight: bold;
    margin-bottom: 29px !important;
  }
}
.bidOrder{
  .wptext{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    margin-bottom: 16px;
  }
  .seemTable{
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    .columnHead{
      padding: 0 24px !important;
      background: #F7F7F7;
      display: flex;
      height: 54px;
      align-items: center;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: rgba(0,0,0,0.85);
      font-weight: bold;
      border-bottom: 1px solid #E8E8E8;
      .part {
        padding-right: 8px !important;
      }
      .n4,.n5,.n6,.n7,.n8{
        flex: 1;
      }
      .n1,.n2,.n3 {
        width: 106px !important;
      }
    }
    .dataItem{
      display: flex;
      align-items: center;
      padding: 16px 24px !important;
      border-bottom: 1px solid #E8E8E8;
      .part {
        padding-right: 8px !important;
      }
      .n4,.n5,.n6,.n7,.n8 {
        flex: 1;
        box-sizing: border-box;
      }
      .n1,.n2,.n3 {
        width: 106px !important;
      }
    }
  }
}
/deep/ .el-table td {
  padding: 4px 4px !important;
  box-sizing: border-box !important;
}
</style>